import { useLocation } from 'react-router-dom';
import StaticCrumb from '../StaticCrumb';

const SERVICES_PATH = '/admin/services';

const ServicesCrumb = () => {
    const location = useLocation();
    const isListPage = location.pathname === SERVICES_PATH;

    return <StaticCrumb label="Services" href={SERVICES_PATH} isCurrentPage={isListPage} />;
};

export default ServicesCrumb;
